import { Component, OnInit, Input, SimpleChanges} from '@angular/core';
import { ApiV2Service } from '../../../../services/api-v2.service';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AuthService } from '../../../../services/auth.service';
import { MessagesModalService } from '../../../../services/messages-modal.service';
import { AuthorCard } from '../../../../interfaces/author-card.interface';
import { PartnerCard } from '../../../../interfaces/partner-card.interface';

@Component({
  selector: 'app-author-card',
  templateUrl: './author-card.component.html',
  styleUrls: ['./author-card.component.css']
})
export class AuthorCardComponent implements OnInit {
  scaleCard: string;
  cardSizeScaled: number;
  @Input() cardSize: number;
  @Input() authorCard: AuthorCard;
  @Input() partnerCard: PartnerCard;

  constructor(
    private api: ApiV2Service,
    private router: Router,
    private spinner: SpinnerService,
    public auth: AuthService,
    private message: MessagesModalService
  ) {
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    this.scaleCard = `scale(${this.cardSize / 240})`;
    this.cardSizeScaled = this.cardSize / (this.cardSize / 240);
  }

  goToInfo(){
    console.log(this.authorCard.id);
    this.router.navigate(['/lessons/public-activities', this.authorCard.id]);
    console.log(this.router);
  }
 
}

